import { Popover } from "@mui/material";
import { useEffect, useState } from "react";

import './ModulesMenu.scss';
import { MobileModal } from "../MobileModal/MobileModal";
import { json, useLocation } from "react-router-dom";
import { getActiveMenuModules } from "../../services/wrapperService";
import { HTTP_RESPONSE_CODES } from "../../globals/globals";
import { useDispatch } from "react-redux";
import { addTab, addTabWithoutActive } from "../../redux/features/TabsManager/tabSlice";

const iconsMap = {
    configModuleIcon                 :"configuration_module_icon"  ,  
engineeringmoduleIcon              :"engineering_module_icon"  ,
storesModuleIcon                    :"store_module_icon"  ,
planningModuleIcon                   :"planning_module_icon"  ,     
maintenanceModuleIcon              :"maintenance_module_icon"  ,
shopMaintenanceIconModule            :"shop_maintenance_module_icon"  , 
reliabilityIconModule            :"reliability_module_icon"  ,
financeIconModule                  :"finance_module_icon"  ,
customersIconModule               :"customers_module_icon"  ,
technicalRecordsIconModule          :"technical_records_module_icon"  ,
homeIconModule                      :"home_icon"  ,
supplyChainIconModule                :"supply-chain"  ,
}


export const ModulesMenu = ({ children, handlerRedirectionModule }) => {

    const [modules, setModules] = useState([]);
    const [showModules, setShowModules] = useState(false);
    const dispatch = useDispatch();

    const handleClick = () => {
        setShowModules(prev => !prev);
    }

    const location = useLocation();
    const getMenuModules = async () => {
        try {
            const dataModules = await getActiveMenuModules();
            if (
                dataModules?.status === HTTP_RESPONSE_CODES.SUCCESS &&
                Array.isArray(dataModules.data?.load)
            ) {
                const modulesLoad = dataModules.data.load;
                const defaultCustomDashoard = {
                    id: 11,
                    title: "Home",
                    color: "#919CE6",
                    icon: "icon-home_icon",
                    path: "/customdashboard",
                    description: "Home",
                    isPinned: false,
                    componentKey: "CustomDashboard",
                    date: crypto.randomUUID(),
                    isModule: true,
                };

                //AddTabModules
                setModules(modulesLoad);
                if (location.pathname == "/secure/customdashboard") {
                    // dispatch(addTab(defaultCustomDashoard));
                } else {
                    // dispatch(addTabWithoutActive(defaultCustomDashoard));
                }
            }
        } catch (error) {
            console.error("Error al obtener los módulos del menú:", error);
        }
    };

    useEffect(()=>{
        getMenuModules();
    }, [])

    // TODO: No modules placeholders.

    return (
        <>
            <div className="modules-menu-component" onClick={handleClick}>
                {children}
            </div>
            <MobileModal open={showModules}>
                {/* {JSON.stringify(modules)} */}
                <div className={`modules-menu-component-grid ${showModules ? "show" : ""}`}>
                    {modules.map((module) => {
                        return (
                            <span className={"module-span-icon"} key={module.id}>
                                <i
                                    style={{
                                        backgroundColor: module.color,
                                    }}
                                    src={""}
                                    alt={module.name}
                                    className={`icon-${iconsMap[module.icon]}`}
                                    onClick={() => {
                                        handleClick();
                                        handlerRedirectionModule?.(module);
                                    }}
                                />{" "}
                                <p className="module-name">{module.name}</p>
                            </span>
                        );
                    })}

                </div>

            </MobileModal>

        </>
    )

}
